import { render } from "./PayPalForm.vue?vue&type=template&id=c40595e6"
import script from "./PayPalForm.vue?vue&type=script&lang=js"
export * from "./PayPalForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__